import Cookies from "js-cookie";
import {Controller} from "stimulus";
import {getActiveCurrency, setActiveCurrency} from "../util/currency";
import {EventCurrencyChanged} from "../events";

const IS_DARK = "is_dark";

export default class extends Controller {
  static targets = ["darkModeToggle", "darkModeButton", "currencyButton", "currencyText"];

  connect() {
    this.darkModeEnabled = Cookies.get(IS_DARK) === "true";
    this.refreshDarkMode();

    window.addEventListener(EventCurrencyChanged, () => {
      let currencyCode = getActiveCurrency();

      document.querySelector("#currencySelector .fa-check")?.classList?.remove("fa-check");
      document.querySelector(`#currencySelector div[data-iso-code='${currencyCode}'] > i`)?.classList.add("fa-check");

      document.querySelector(`#currencySelector div.tw-bg-gray-100`)?.classList.remove("tw-bg-gray-100", "dark:tw-bg-moon-700");
      document.querySelector(`#currencySelector div[data-iso-code='${currencyCode}']`)?.classList.add("tw-bg-gray-100", "dark:tw-bg-moon-700");

      this.currencyButtonTargets.forEach(target => { target.textContent = currencyCode.toUpperCase(); });
      this.currencyTextTargets.forEach(target => { target.textContent = currencyCode.toUpperCase(); });
    });
  }

  toggleDarkMode() {
    this.darkModeEnabled = !this.darkModeEnabled;
    Cookies.set(IS_DARK, String(this.darkModeEnabled), { expires: 365 });

    this.refreshDarkMode();
  }

  refreshDarkMode() {
    this.darkModeToggleTarget.checked = this.darkModeEnabled;
    this.darkModeButtonTarget.classList.toggle("fa-sun", !this.darkModeEnabled);
    this.darkModeButtonTarget.classList.toggle("fa-moon", this.darkModeEnabled);

    // TODO: Remove 'darktheme' class usage after fully migrated to AppV2.
    document.body.classList.toggle("darktheme", this.darkModeEnabled);
    document.body.classList.toggle("tw-dark", this.darkModeEnabled);

    const swaggerCSS = document.getElementById("swagger-css-link")
    if (swaggerCSS) {
      swaggerCSS.href = this.darkModeEnabled ? "/api/documentations/swagger-ui-dark.css" : "/api/documentations/swagger-ui.css";
    }
  }

  changeCurrency(e) {
    const currencyCode = e.currentTarget.getAttribute("data-iso-code");
    setActiveCurrency(currencyCode);

    let event = new CustomEvent(EventCurrencyChanged, { bubbles: true, detail: { currencyCode } });
    this.element.dispatchEvent(event);

    Modal.hide("currency_selector");
  }
}
